import type {
  AccountPlatformType,
  AccountType,
} from "../../../shared/types/accounts";
import { FACEBOOK_GROUPS_REMOVED_MSG } from "../../../constants/TooltipMessages";
import {
  accountTypesToSelectorAccounts,
  type SelectorAccountHealthOptions,
} from "../../ui/selectors/adapters";
import type { SelectorAccount } from "../../ui/selectors/types";

// SKE-4694. Existing Facebook Group rows stay listed but cannot be picked.
const isFacebookGroup = (account: AccountType) => account.isGroup === true;

export function filterPostFormPickerAccounts(
  accounts: AccountType[],
  platforms?: AccountPlatformType[]
): AccountType[] {
  if (!platforms?.length) return accounts;
  return accounts.filter((account) =>
    platforms.includes(account.platformType || "IG")
  );
}

export function postFormPickerSelectorAccounts(
  accounts: AccountType[],
  options: SelectorAccountHealthOptions
): SelectorAccount[] {
  const groupIds = new Set(
    accounts.filter(isFacebookGroup).map((account) => account._id)
  );
  return accountTypesToSelectorAccounts(accounts, options).map(
    (selectorAccount) =>
      groupIds.has(selectorAccount.id)
        ? {
            ...selectorAccount,
            // The menu row ignores hover on disabled items, so the reason is
            // also the visible second line, and there is nothing to reconnect.
            secondaryText: FACEBOOK_GROUPS_REMOVED_MSG,
            disconnected: false,
            attentionReason: undefined,
            disabled: true,
            disabledReason: FACEBOOK_GROUPS_REMOVED_MSG,
          }
        : selectorAccount
  );
}

export function resolvePostFormPickerSelection(
  accounts: AccountType[],
  selectedIds: string[]
): AccountType[] {
  const selected = new Set(selectedIds);
  return accounts.filter(
    (account) => selected.has(account._id) && !isFacebookGroup(account)
  );
}
